import React from 'react';
import { Link } from 'react-router-dom';
import { Reveal } from '../components/Reveal';
import { LogoLockup } from '../components/Logo';
import {
  about,
  aboutFaqs,
  certificates,
  education,
  experience,
  site,
  skillGroups,
} from '../data/site';

const About: React.FC = () => (
  <>
    <header className="page-intro about-intro">
      <div className="wrap">
        <LogoLockup />
        <h1>{about.lead}</h1>
        <p className="about-dek">{about.dek}</p>
      </div>
    </header>

    <div className="wrap about-grid">
      <div className="prose">
        <p>{about.p1}</p>
        <blockquote className="pullquote">{about.quote}</blockquote>
        <p>{about.p2}</p>
        <p>{about.p3}</p>
      </div>
      <aside className="facts">
        <div>
          <strong>Konum</strong>
          <span>{site.location}</span>
        </div>
        <div>
          <strong>Şu an</strong>
          <span>CEM Teknoloji · Assistant Project Manager</span>
        </div>
        <div>
          <strong>Odak</strong>
          <span>ERP, MRP, full stack ürün</span>
        </div>
        <div>
          <strong>İletişim</strong>
          <span>
            <a href={`mailto:${site.email}`}>{site.email}</a>
          </span>
        </div>
        <div>
          <strong>Mağazalar</strong>
          <span>
            {site.stores.map((store, i) => (
              <React.Fragment key={store.href}>
                {i > 0 ? ' · ' : null}
                <a href={store.href} target="_blank" rel="noopener noreferrer">
                  {store.label}
                </a>
              </React.Fragment>
            ))}
          </span>
        </div>
      </aside>
    </div>

    <div className="wrap faq-block">
      <p className="eyebrow">Sık sorulanlar</p>
      <h2 className="section-title" style={{ paddingTop: 0 }}>Mustafa Gürses hakkında</h2>
      <dl className="faq-list">
        {aboutFaqs.map((item) => (
          <div className="faq-item" key={item.q}>
            <dt>{item.q}</dt>
            <dd>{item.a}</dd>
          </div>
        ))}
      </dl>
    </div>

    <div className="wrap">
      <p className="eyebrow">Deneyim</p>
      <h2 className="section-title" style={{ paddingTop: 0 }}>Profesyonel deneyim</h2>
      {experience.map((job) => (
        <Reveal key={`${job.org}-${job.period}`}>
          <article className="exp-item">
            <div className="exp-period">{job.period}</div>
            <div>
              <h3>
                {job.role} <span>@ {job.org}</span>
              </h3>
              <ul>
                {job.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>
              {job.tech.length > 0 && (
                <div className="meta-row" style={{ marginTop: 12 }}>
                  {job.tech.map((t) => (
                    <span className="chip" key={t}>
                      {t}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </article>
        </Reveal>
      ))}
    </div>

    <div className="wrap" style={{ padding: '64px 0 24px' }}>
      <p className="eyebrow">Eğitim</p>
      <div className="edu-grid" style={{ marginTop: 16 }}>
        {education.map((ed) => (
          <article className="panel" key={ed.school}>
            <p>{ed.years}</p>
            <h3>{ed.title}</h3>
            <p>{ed.school}</p>
            <p style={{ marginTop: 8 }}>{ed.text}</p>
          </article>
        ))}
      </div>
    </div>

    <div className="wrap" style={{ padding: '32px 0' }}>
      <p className="eyebrow">Teknolojiler</p>
      {skillGroups.map((g) => (
        <div className="skill-block" key={g.title} style={{ marginTop: 18 }}>
          <h3>{g.title}</h3>
          <div className="meta-row">
            {g.items.map((item) => (
              <span className="chip" key={item}>
                {item}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>

    <div className="wrap" style={{ padding: '24px 0 48px' }}>
      <p className="eyebrow">Sertifikalar</p>
      <div className="cert-grid" style={{ marginTop: 16 }}>
        {certificates.map((c) => (
          <article className="panel" key={c.title}>
            <p>{c.date} · {c.org}</p>
            <h3>{c.title}</h3>
            {c.note ? <p>{c.note}</p> : null}
          </article>
        ))}
      </div>
    </div>

    <section className="cta-band">
      <div className="wrap">
        <h2>Projenizi konuşalım.</h2>
        <p>Kurumsal yazılım, ERP ve dijital ürün ihtiyaçlarınız için iletişime geçebilirsiniz. Gaziantep merkezli, Türkiye ve uluslararası projelerde çalışıyorum.</p>
        <Link to="/contact" className="btn btn-fill">
          İletişime geç
        </Link>
      </div>
    </section>
  </>
);

export default About;
